/* eslint-disable */
import throwI18nInvalidLangError from '../../../Errors/I18n/I18nInvalidLang.error';

/**
 * Determine if a provided `lang` is indeed a valid `lang`
 * @export
 * @param {I18nEntityLangs} lang The `lang` to use to find the `locale`
 * @param {Array<I18nEntityLocale>} locales The `locales` to validate against
 * @returns {I18nEntityLocale} The found `locale`
 */
const i18nFindLocaleByLang = (lang, locales) => {
  const foundLocale = locales.find((locale) => locale.lang === lang);
  if (foundLocale === undefined) {
    return throwI18nInvalidLangError(lang, locales);
  }
  return foundLocale;
};

export default i18nFindLocaleByLang;
